import { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { useNavigate, useLocation } from 'react-router-dom';
import { loginRequest, LOGIN_TYPE } from '@/app/authConfig';
import { paths } from '@/app/routes';

export const useMsalAuthState = (account) => {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const checkAuthState = async () => {
			if (!account?.homeAccountId) return;

			const currentAccount = instance.getAccountByHomeId(account.homeAccountId);
			if (!currentAccount) return;

			let activeAccount = instance.getActiveAccount();
			if (activeAccount?.username !== currentAccount?.username) {
				instance.setActiveAccount(currentAccount);
				activeAccount = instance.getActiveAccount();
			}

			const request = { ...loginRequest, account: currentAccount };
			try {
				await instance.acquireTokenSilent(request);
			} catch (error) {
				console.error('Error refreshing token', error);
				if (error instanceof InteractionRequiredAuthError) {
					if (LOGIN_TYPE === 'popup') {
						await instance.acquireTokenPopup(request);
					} else {
						await instance.acquireTokenRedirect(request);
					}
				}
			}
		};

		if (isAuthenticated) {
			checkAuthState();
			const intervalId = setInterval(checkAuthState, 300000); // every 5 min
			return () => clearInterval(intervalId);
		} else if (location.pathname !== '/') {
			navigate(paths.home);
		}
	}, [isAuthenticated, instance, account, navigate, location]);
};
